import {isProduction} from "../function/base/checkProduct"
import {Timer} from "../function/base/timer"
import {ControlState} from "./interface/controlInterface"
import {Action} from "./interface/baseInterface"
const invokeAsync = (key: string, value: any) => {
    isProduction ? null : console.log(key, value)
}
const defaultPosition = {
    leftTop: {
        x: 0,
        y: 0,
    },
    rightBottom: {
        x: 0,
        y: 0,
    },
    leftBottom: {
        x: 0,
        y: 0,
    },
    rightTop: {
        x: 0,
        y: 0,
    },
}
const controlState = {
    pollingSteps: {step1: false, step2: false, step3: false, step4: false, step5: false},
    loading: false,
    model: {
        invokeAsync: invokeAsync,
    },
    pageJump: {
        Base: {
            blockPos: defaultPosition,
            blockVisualPos: {
                height: 0,
            },
            mappingPos: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            },
            pageNum: 1,
            from: "Base",
            jump: false,
            find: false,
        },
        Compare: {
            blockPos: defaultPosition,
            mappingPos: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            },
            pageNum: 1,
            from: "Compare",
            jump: false,
            follow: false,
            find: false,
        },
        diffIndex: 1,
        diffType: "",
        listJump: false,
    },
    timer: new Timer(),
    showErrorLog: false,
    scrollControl: {
        type: "",
        top: 0,
        bottom: 0,
    },
    pageItemPosition: {
        Base: [],
        Compare: [],
    },
    comparisonStatus: {
        id: "",
        status: "waiting",
        msg: "开始比对",
        errorMsg: {
            taskId: "",
            traceId: "",
            progress: "",
        },
    },
    activeView: "operate",
}
const contain = (scrollControl: any, position: any) => {
    const top = position.top
    const bottom = position.bottom
    if (scrollControl.top >= top && scrollControl.top <= bottom) {
        return true
    } else if (scrollControl.bottom >= top && scrollControl.bottom <= bottom) {
        return true
    } else if (scrollControl.top <= top && scrollControl.bottom >= bottom) {
        return true
    } else {
        return false
    }
}
export const controlReducer = (state: ControlState = controlState, action: Action) => {
    const payload = action.payload
    switch (action.type) {
        case "TDAInit": {
            state.timer.stop()
            state.timer.clearTimer()
            return {
                ...controlState,
            }
        }
        case "onPageJump": {
            return {
                ...state,
                pageJump: payload,
            }
        }
        case "showErrorLog": {
            return {
                ...state,
                showErrorLog: true,
            }
        }
        case "savePageItemPosition": {
            return {
                ...state,
                pageItemPosition: {
                    ...state.pageItemPosition,
                    [payload.type]: state.pageItemPosition[payload.type]
                        .filter((item: any) => item.pageNum !== payload.pageNum)
                        .concat(payload),
                },
            }
        }
        case "saveAllPageItemPosition": {
            return {
                ...state,
                pageItemPosition: payload,
            }
        }
        case "handleChangeScrollControl": {
            return {
                ...state,
                scrollControl: payload,
            }
        }
        case "hiddenErrorLog": {
            return {
                ...state,
                showErrorLog: false,
            }
        }
        case "controlInit": {
            state.timer.stop()
            state.timer.clearTimer()
            return {
                ...controlState,
            }
        }
        case "setModel":
            state.timer.setModel(payload)
            return {
                ...state,
                model: payload,
            }
        case "startComparisonWithId":
            state.timer.setId(payload)
            // state.timer.start()
            return {
                ...state,
                loading: true,
                pollingSteps: {step1: false, step2: false, step3: false, step4: false, step5: false},
                comparisonStatus: {
                    id: payload,
                    status: "loading",
                    msg: "开始比对",
                },
            }
        case "saveQueryId":
            return {
                ...state,
                comparisonStatus: {
                    ...state.comparisonStatus,
                    id: payload,
                },
            }
        case "pollingError":
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            // state.model.invokeAsync("resultData", {
            //     code: "0",
            //     message: "未知错误，请联系管理员。",
            // })
            if (state.activeView === "display" && state.comparisonStatus.status === "loading") {
                state.timer.stop()
                state.timer.clearTimer()
                return {
                    ...state,
                    loading: false,
                    comparisonStatus: {
                        id: "",
                        status: "error",
                        msg: "未知错误，请联系管理员。",
                        errorMsg: {
                            taskId: payload.taskId,
                            traceId: payload.traceId,
                            progress: payload.progress,
                        },
                    },
                }
            } else {
                return {
                    ...state,
                }
            }

        case "pollingLoading":
            if (state.activeView === "display" && state.comparisonStatus.status === "loading") {
                return {
                    ...state,
                    loading: true,
                    comparisonStatus: {
                        ...state.comparisonStatus,
                        status: "loading",
                    },
                    pollingSteps: state.timer.getStep(),
                }
            } else {
                return {
                    ...state,
                }
            }
        case "pollingSuccess":
            if (state.activeView === "display" && state.comparisonStatus.status === "loading") {
                state.timer.stop()
                state.timer.clearTimer()
                return {
                    ...state,
                    // loading: false,
                    // comparisonStatus: payload.comparisonStatus,
                    loading: true,
                    comparisonStatus: {
                        ...state.comparisonStatus,
                        status: "loading",
                    },
                    pollingSteps: {step1: true, step2: true, step3: true, step4: true, step5: true},
                }
            } else {
                return {...state}
            }

        case "stopPolling":
            state.timer.stop()
            state.timer.clearTimer()
            return {
                ...state,
            }
        case "startLoading":
            return {
                ...state,
                loading: payload,
                pollingSteps: controlState.pollingSteps,
                comparisonStatus: {
                    ...state.comparisonStatus,
                    status: "loading",
                },
            }
        case "queryControlStatus":
            if (state.activeView === "display" && state.comparisonStatus.status === "loading") {
                return {
                    ...state,
                    loading: false,
                    comparisonStatus: payload.comparisonStatus,
                }
            } else {
                return {...state}
            }
        case "activeView":
            return {
                ...state,
                activeView: payload,
            }
        default:
            return {...state}
    }
}
